import { useState, useEffect, useContext, useRef } from 'react';
import './admin.css'
import {auth} from '../../fireconnection';
import { db } from '../../fireconnection';
import { signOut } from 'firebase/auth';
import { UserContext } from '../../contexts/user';

import { addDoc, doc, updateDoc, collection, deleteDoc, Firestore , onSnapshot, query, orderBy, where } from 'firebase/firestore';
import { toast } from 'react-toastify';

export default function Admin() {

    const {userDoContext} = useContext(UserContext)

    const [tarefaInput, setTarefaInput] = useState('');
    const [user, setUser] = useState({});
    const [tarefas, setTarefas] = useState([]);
    const [edit, setEdit] = useState('');

    useEffect(()=>{
        async function loadTarefas() {
            // const userDetail = localStorage.getItem('@detailUser');
            // setUser(JSON.parse(userDetail));
            setUser(userDoContext);

            if(userDoContext){
                // const data = JSON.parse(userDetail);

                const tarefaRef = collection(db, 'tarefas');
                const q = query(tarefaRef, orderBy('created', 'desc'), where('userUid','==', userDoContext?.uid));
                const unsub = onSnapshot(q, (snapshot) => {
                    let lista = [];

                    snapshot.forEach( doc => {
                        lista.push({
                            id: doc.id,
                            tarefa: doc.data().tarefa,
                            userUid: doc.data().userUid,
                        })
                    } )
                    setTarefas(lista);
                })
            }

        }
        loadTarefas()
    }, [])

    async function handleRegister(e){
        e.preventDefault();

        if(tarefaInput === ''){
            toast.warn('Digite sua tarefa...')
            return
        }

        if(edit){
            handleUpdateTarefa();
            return
        }

        await addDoc(collection(db, "tarefas"), {
            tarefa: tarefaInput,
            created: new Date(),
            userUid: user?.uid
            
        })
        .then(()=>{
            toast.success("Tarefa Registrada");
            setTarefaInput('');
        }).catch(err => {
            toast.error("Erro ao registrar")
            console.log(err);
        })

    }

    async function handleLogout(){
        await signOut(auth);
    }

    async function deleteTarefa(id){
        const docRef = doc(db, "tarefas", id);
        await deleteDoc(docRef);
        toast.success("Tarefa Concluida!")
    }

    async function editeTarefa(item) {
        setTarefaInput(item.tarefa);
        setEdit(item);
    }

    async function handleUpdateTarefa() {
        const docRef = doc(db, 'tarefas', edit?.id);
        await updateDoc(docRef, {
            tarefa: tarefaInput
        })
        .then(()=>{
            toast.success("Tarefa editada!")
            setTarefaInput('');
            setEdit('');
        })
        .catch(err => {
            console.log("Houve um equivoco: ", err )
            setTarefaInput('');
            setEdit('');
        })
    }

 return (
   <div className='admin-container'>
    <h1>Minhas tarefas</h1>

    <form onSubmit={handleRegister} className='form'>
        <textarea
            placeholder='Digite sua tarefa...'
            value={tarefaInput}
            onChange={e => setTarefaInput(e.target.value)}
        />
        {edit ? (
            <button type='submit' className='btn-register' >Atualizar tarefa</button>
        ) : (
            <button type='submit' className='btn-register' >Registrar tarefa</button>
        )}
    </form>

    {tarefas.map(item => (
            <article className='list' key={item.id}>
            <p>{item.tarefa}</p>
            <div>
                <button onClick={() => editeTarefa(item)}>Editar</button>
                <button className='btn-delete' onClick={() => deleteTarefa(item.id)} >Concluir</button>
            </div>
        </article>
    ))}

    <button className='btn-logout' onClick={handleLogout}>Sair</button>
   </div>
 );
}